import { EntTypeProductFilter } from "../../../models/filters/TypeProductFilter";
import { EntTypeProduct } from "../../../models/handBooks/typeProduct";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";

export const GeneralproductTypesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getGeneralProductTypeList: builder.query<ResponseDataGet<EntTypeProduct>, EntTypeProductFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.generalProductCategory }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getGeneralProductTypeById: builder.query<ResponseDataTest<EntTypeProduct>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.generalProductCategory }/${ id }`,
		method: 'GET'
	  })
	}),
	addGeneralProductType: builder.mutation<ResponseDataTest<EntTypeProduct>, EntTypeProduct>({
	  query: (body) => ({
		url: `${ Paths.handbooks.generalProductCategory }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editGeneralProductType: builder.mutation<ResponseDataTest<EntTypeProduct>, EntTypeProduct>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.generalProductCategory }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteGeneralProductType: builder.mutation<ResponseDataTest<EntTypeProduct>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.generalProductCategory }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddGeneralProductTypeMutation,
  useDeleteGeneralProductTypeMutation,
  useEditGeneralProductTypeMutation,
  useLazyGetGeneralProductTypeListQuery
} = GeneralproductTypesApi;
